export const SENSOR_CONNECTION_STATUS = {
  CONNECTED: "Connected",
  DISCONNECTED: "Disconnected",
};

const normalizeStatusValue = (value) =>
  String(value || "")
    .trim()
    .toLowerCase();

export const getSensorStatus = (sensorOrState) => {
  const state = sensorOrState?.state ?? sensorOrState;
  const rawStatus =
    typeof state === "string" ? state : state?.status ?? sensorOrState?.status;
  const normalizedStatus = normalizeStatusValue(rawStatus);

  if (!normalizedStatus) {
    return null;
  }

  if (
    normalizedStatus.includes("disconnect") ||
    normalizedStatus.includes("disconness") ||
    normalizedStatus === "offline" ||
    normalizedStatus === "not_connected" ||
    normalizedStatus === "not connected"
  ) {
    return SENSOR_CONNECTION_STATUS.DISCONNECTED;
  }

  if (
    normalizedStatus === "connected" ||
    normalizedStatus === "connesso" ||
    normalizedStatus === "online"
  ) {
    return SENSOR_CONNECTION_STATUS.CONNECTED;
  }

  return rawStatus;
};

export const isSensorDisconnected = (sensorOrState) =>
  getSensorStatus(sensorOrState) === SENSOR_CONNECTION_STATUS.DISCONNECTED;

export const isSensorConnected = (sensorOrState) =>
  getSensorStatus(sensorOrState) === SENSOR_CONNECTION_STATUS.CONNECTED;

export const getSensorStatusLabel = (sensorOrState) => {
  const status = getSensorStatus(sensorOrState);

  if (status === SENSOR_CONNECTION_STATUS.DISCONNECTED) {
    return "Disconnesso";
  }

  if (status === SENSOR_CONNECTION_STATUS.CONNECTED) {
    return "Connesso";
  }

  return "Sconosciuto";
};
